export function imageGallery() {
  let initializedClassName = 'initialized';

  $('.image-gallery-slider').each(function () {
    let slider = $(this);

    if (!slider.hasClass(initializedClassName)) {
      let items = slider.find('.image-gallery-item');

      if (items.length > 1) {
        slider
          .addClass(initializedClassName)
          .slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            swipeToSlide: true
          });
      }
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/image-gallery.js